import { injectIntl } from 'react-intl';
import ClientRedirect from './ClientRedirect';
import config from './config';

export const CONFIG = config;

export default injectIntl(ClientRedirect);
